import { useQuery } from "react-query";
import { useWorkflowsApi } from "@/react/api";

export const useCommunityCurrentUsageStats = (queryOptions = {}) => {
  const workflowsApi = useWorkflowsApi();
  return useQuery(
    ["workflows-community-current-usage-stats"],
    () => workflowsApi.fetchCommunityCurrentUsageStats(),
    {
      ...queryOptions,
    },
  );
};
